/* eslint-disable */

import $ from 'jquery';
import 'resize-end';

// allow to use simple <img ... data-srset="mobileImage.jpg 768px, tabletImage.jpg 1280px, desktopImage.jpg" />
// to implement responsive images, no matter if the bigger version of the image is also known by the browser cache
// and no matter if this is a hdpi device.
// this was working like this with older versions of lazyloadxt but does not work anymore, because lazyloadxt is now
// using the browser's native srcset - this script reproduces to former behaviour.
// todo: better long term solution would be to use picture tag with real support for responsive images everywhere
$(document).ready(function () {
  updateSrcset();
});
$(window).on('resizeend scrollend lazyload lazycomplete', function () {
  updateSrcset();
});
function updateSrcset () {
  const windowWidth = $(window).innerWidth();
  $('img.lazy-loaded[data-srcset]').each(function () {
    const imageElem = $(this);
    const src = imageElem.attr('src');
    if (!src || src.indexOf('data:') === 0) {
      // do not set srcset, if src was not set yet (or src only set to placeholder image data:...)
      return;
    }

    const set = imageElem.attr('data-srcset').split(',');
    for (var i = 0; i < set.length; i++) {
      const srcAndWidth = set[i].trim().split(' ');
      var width = 999999;
      if (srcAndWidth.length === 2) {
        width = (srcAndWidth[1] + '').replace('w', '');
      }
      if (windowWidth <= width) {
        imageElem.attr('srcset', set[i].trim());
        break;
      }
    }
  });
}



// WEBPACK FOOTER //
// ./custom_dependencies/brandhub-embxp-frontend/daimler-brandhub-modules/daimler-brandhub-design/daimler-brandhub-design-package/frontend/src/common/js/lazyload/lazyload-srcset-responsiveimage.js